import styled from 'styled-components';

export const WindowedGridViewport = styled.div`
  width: 100%;
  padding-bottom: 16px;
  animation: fade-in-up 400ms ease-out;

  @keyframes fade-in-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const WindowedGridInner = styled.div`
  width: 100%;
`;

export const WindowedGridList = styled.ul<{
  $columns: number;
  $gap: number;
}>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, minmax(0, 1fr));
  justify-items: center;
  align-items: start;
  gap: ${({ $gap }) => `${$gap}px`};
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
`;
